import PropTypes from 'prop-types';
import SentryTypes from 'app/sentryTypes';
import React from 'react';

import {defined} from 'app/utils';
import Annotated from 'app/components/events/meta/annotated';
import ExceptionMechanism from 'app/components/events/interfaces/exceptionMechanism';
import StacktraceContent from 'app/components/events/interfaces/stacktraceContent';

class ExceptionContent extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['original', 'minified']),
    values: PropTypes.array.isRequired,
    view: PropTypes.string.isRequired,
    platform: PropTypes.string,
    newestFirst: PropTypes.bool,
    group: SentryTypes.Group,
  };

  render() {
    const stackView = this.props.view;
    const newestFirst = this.props.newestFirst;
    const group = this.props.group;
    const children = this.props.values.map((exc, excIdx) => {
      return (
        <div key={excIdx} className="exception">
          <h5 className="break-word" style={{marginBottom: 5}}>
            <span>{exc.type}</span>
          </h5>

          <Annotated object={exc} prop="value" required>
            {value => (
              <pre className="exc-message" style={{marginTop: 0}}>
                {value}
              </pre>
            )}
          </Annotated>

          {exc.mechanism && (
            <ExceptionMechanism data={exc.mechanism} platform={this.props.platform} />
          )}
          {defined(exc.stacktrace) && (
            <StacktraceContent
              data={
                this.props.type === 'original'
                  ? exc.stacktrace
                  : exc.rawStacktrace || exc.stacktrace
              }
              expandFirstFrame={excIdx === 0}
              includeSystemFrames={stackView === 'full'}
              platform={this.props.platform}
              newestFirst={newestFirst}
              group={group}
            />
          )}
        </div>
      );
    });
    if (newestFirst) {
      children.reverse();
    }

    // TODO(dcramer): implement exceptions omitted
    return <div>{children}</div>;
  }
}

export default ExceptionContent;
